// Runtime config for the Helm web console.
//
// Deployed: same origin. The SPA sits behind the edge Caddy (helm-dev.kstack.app), which reverse-proxies /v1/* + /auth/*
// to the Nexus kstack-dev instance and stamps x-nexus-app-key server-side — so there is no CORS and the app key never
// ships in the bundle (the StoreFront mechanism, copied).
//
// VITE_NEXUS_BASE overrides the origin for local work (e.g. https://nexus-dev.kstack.app); a cross-origin base needs
// CORS on Nexus and VITE_APP_KEY, because no edge is stamping the key then. Leave both unset for a deployed build.

export const APP_ID = 'helm' as const;

export const NEXUS_BASE: string = (import.meta.env.VITE_NEXUS_BASE ?? '').replace(/\/+$/, '');

/** Local-dev only. Empty in every deployed build. */
export const DEV_APP_KEY: string = import.meta.env.VITE_APP_KEY ?? '';

export const HELM_FN_URL = `${NEXUS_BASE}/v1/app/${APP_ID}/fn/helm_api`;
export const AUTH_URL = (path: string): string => `${NEXUS_BASE}/auth/${path}`;

/** What Settings shows as the Nexus host. */
export function nexusHostLabel(): string {
  if (NEXUS_BASE) { try { return new URL(NEXUS_BASE).host; } catch { return NEXUS_BASE; } }
  return 'nexus-dev.kstack.app (same-origin via the edge)';
}
export const STAGE_LABEL = 'Dev';

/** Origin of the agent_memory web app, whose /memory/:slug page shows (and edits) one memory. Unset = no "Open in
 *  agent_memory" link: the Brain's details panel (/brain?memory=<slug>) is then the link. Only https origins count. */
export const AGENT_MEMORY_WEB_BASE: string = (() => {
  const v = (import.meta.env.VITE_AGENT_MEMORY_WEB_BASE ?? '').trim().replace(/\/+$/, '');
  try { return v && new URL(v).protocol === 'https:' ? v : ''; } catch { return ''; }
})();
export const APP_VERSION: string = typeof __APP_VERSION__ === 'string' ? __APP_VERSION__ : 'dev';
